import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Observable } from 'rxjs';
import { RestService } from '../../core/rest.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable()
export class PrintoutService {
  private getPdfFromProcedureRestPath = 'api/printout/pdffromprocedure';

  constructor(
    private restService: RestService
  ) { }

  public makePdfFromProcedure(procedureName: string, params: any) {
    let printoutParameters = { procedureName: procedureName, parameters: params };
    this.getPdfFromProcedure(printoutParameters).subscribe(pdfData => {
      if (!pdfData) {
        return;
      }
      let pdfObject = JSON.parse(pdfData);

      let pdfDoc = pdfMake.createPdf(pdfObject);
      pdfDoc.open();
    });
  }

  public makePdfFromJson(pdfData: string) {
    if (!pdfData) {
      return;
    }

    let pdfObject = JSON.parse(pdfData);

    let pdfDoc = pdfMake.createPdf(pdfObject);
    pdfDoc.open();
  }

  public makePdfFromObject(pdfDefinition: any) {
    if (!pdfDefinition) {
      return;
    }

    let pdfDoc = pdfMake.createPdf(pdfDefinition);
    pdfDoc.open();
  }

  private getPdfFromProcedure(printoutParameters: any): Observable<string> {
    return this.restService.post<string>(this.getPdfFromProcedureRestPath, printoutParameters);
  }
}
